import { NotificationGroup, UnreadCountByGroup } from "types/Notification";
import { ActionTypeData } from "reducers/Action";

export interface NotificationState {
  unreadCountByGroup: Partial<Record<NotificationGroup, number>>;
}

const initialState: NotificationState = {
  unreadCountByGroup: {},
};

type AllActions =
  | ActionTypeData<"SET_UNREAD_COUNT_BY_GROUP", UnreadCountByGroup>
  | ActionTypeData<"INCREMENT_UNREAD_COUNT", NotificationGroup>
  | ActionTypeData<"DECREMENT_UNREAD_COUNT", NotificationGroup>;

export default function notificationReducer(
  state: NotificationState = initialState,
  action: AllActions,
): NotificationState {
  switch (action.type) {
    // Polling : remplace tous les compteurs par les valeurs fraîches du serveur ~30s
    case "SET_UNREAD_COUNT_BY_GROUP": {
      return { unreadCountByGroup: action.payload };
    }

    // markAsRead(id) : décrémente, jamais en dessous de 0
    // action.payload = type de notif (METIER, INFO, ...)
    case "DECREMENT_UNREAD_COUNT": {
      const current = state.unreadCountByGroup[action.payload] ?? 0;
      return {
        unreadCountByGroup: {
          ...state.unreadCountByGroup,
          [action.payload]: Math.max(0, current - 1),
        },
      };
    }

    // SSE nouvelle notif : incrémente le compteur du groupe concerné
    // action.payload = type de notif (METIER, INFO, ...)
    case "INCREMENT_UNREAD_COUNT": {
      const current = state.unreadCountByGroup[action.payload] ?? 0;
      return {
        unreadCountByGroup: {
          ...state.unreadCountByGroup,
          [action.payload]: current + 1,
        },
      };
    }

    default:
      return state;
  }
}
